import { TutorialCard, TutorialStep } from "@/components/tutorial/TutorialCard";

const LABELING_TIPS: TutorialStep[] = [
    {
        icon: "fad fa-vector-square",
        title: "Draw Precise Boxes",
        description:
            "Draw boxes that tightly fit around objects. Avoid including too much background or cutting off parts of the object.",
        videoSrc: "/videos/labeling-guide/tip1-be-precise.mp4"
    },
    {
        icon: "fad fa-magnifying-glass",
        title: "Use the Zoom Tools",
        description:
            "Zoom in to label small or dense objects accurately, and zoom out to check context before saving.",
        videoSrc: "/videos/labeling-guide/tip2-use-zoom.mp4"
    },
    {
        icon: "fad fa-layer-group",
        title: "Include Variety",
        description:
            "Label objects in different sizes, angles, lighting conditions, and backgrounds for a more robust model.",
        videoSrc: "/videos/labeling-guide/tip3-angles.mp4"
    }
];

interface LabelingGuideProps {
    isOpen: boolean;
    onClose: () => void;
}

export function LabelingGuide({ isOpen, onClose }: LabelingGuideProps) {
    return (
        <TutorialCard
            standalone
            isOpen={isOpen}
            onClose={onClose}
            steps={LABELING_TIPS}
            initialPosition="bottom-right"
            autoPlay
        />
    );
}
